module.exports = __webpack_public_path__ + "assets/GoldZeta2x.4bc250ac21d723fff221d01ac376b257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldZeta2x.png
// module id = 827
// module chunks = 0